import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VForm,[_c(VRow,[_c(VCol,[_c(VTextField,{attrs:{"type":"date","label":"Fecha","required":"","error-messages":_vm.errors['date']},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1)],1),_c(VRow,[_c(VCol,{attrs:{"align":"right"}},[_c(VSpacer),_c(VBtn,{attrs:{"text":"","color":"primary"},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }